import { AnyObject, BaseQuery as ChempoBaseQuery, QueryFilter, QuerySort } from '@chem-po/core'
import { BaseQuery, CollectionFilter, CollectionSort } from '../types'

export const toChempoFilter = <T extends AnyObject>(
  filter: CollectionFilter<T>,
): QueryFilter<T> => {
  const [key, operator, value] = filter
  return {
    key,
    operator: operator as QueryFilter<T>['operator'],
    value,
  }
}

export const toChempoSort = <T extends AnyObject>(sort: CollectionSort<T>): QuerySort<T> => {
  const { field, order } = sort
  return {
    key: field,
    direction: order,
  }
}

export const toHbFilter = <T extends AnyObject>(filter: QueryFilter<T>): CollectionFilter<T> => {
  const { key, operator, value } = filter
  return [key, operator, value]
}

export const toHbSort = <T extends AnyObject>(sort: QuerySort<T>): CollectionSort<T> => {
  const { key, direction } = sort
  return {
    field: key,
    order: direction,
  }
}

export const toChempoQuery = <T extends AnyObject>(
  baseQuery: BaseQuery<T>,
): ChempoBaseQuery<T> => ({
  collection: baseQuery.collection,
  filters: baseQuery.filters?.map(toChempoFilter) ?? [],
  cursor: baseQuery.startAfterId,
  limit: baseQuery.limit,
  sort: baseQuery.sort?.length ? toChempoSort(baseQuery.sort[0]) : undefined,
})

export const toHbQuery = <T extends AnyObject>(chempoQuery: ChempoBaseQuery<T>): BaseQuery<T> => ({
  collection: chempoQuery.collection,
  filters: chempoQuery.filters?.map(toHbFilter) ?? [],
  limit: chempoQuery.limit,
  sort: chempoQuery.sort ? [toHbSort(chempoQuery.sort)] : undefined,
  startAfterId: chempoQuery.cursor,
})
